import React from 'react';
import { StyleSheet, View } from 'react-native';

import { colors, scale } from '../../Styles';
import { OverViewProps } from '../containers/AcademicOverviewContainer';
import { MNOHSAcademicGrid } from '../MNOHSAcademicGrid';
import { MNOHSCourseGrid } from '../MNOHSCourseGrid';
import { MNOHSCourseLegends } from '../MNOHSCourseLegends';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';
import { MNOHSFloatingIndicator } from '../MNOHSFloatingIndicator';

export const AcademicOverviewScreen: React.FC<OverViewProps> = ({
  courseGroups,
  isGettingCourseGroups,
  userPressedCourseDetails,
}) => {
  return (
    <MNOHSDashboardWrapper headerTitle={'Academic Overview'}>
      <View style={styles.overviewContainer}>
        {Boolean(isGettingCourseGroups) ? (
          <MNOHSFloatingIndicator style={{ position: undefined }} />
        ) : (
          <MNOHSAcademicGrid courseGroups={courseGroups} />
        )}
        <MNOHSCourseLegends />
      </View>

      <View style={styles.courseDetailsContainer}>
        <MNOHSCourseGrid userPressedCourseDetails={userPressedCourseDetails} />
      </View>
    </MNOHSDashboardWrapper>
  );
};

const styles = StyleSheet.create({
  overviewContainer: {
    marginHorizontal: scale(16),
    paddingTop: '5%',
    paddingBottom: '2%',
    flex: 1,
    backgroundColor: colors.grayLight,
    alignItems: 'flex-start',
  },
  courseDetailsContainer: {
    padding: scale(20),
  },
});
